import { buttonClass } from "@/components/buttonStyles";

/** What a step reads when it opens couldn't be read: what went wrong, with
 *  Retry. The People step and the contacts read the submission's people
 *  (BRK-S303, BRK-S337), the Questions step the WC manifest (BRK-S304). */
export function StepLoadProblem({
  problem,
  onRetry,
}: {
  problem: string;
  onRetry: () => void;
}) {
  return (
    <div
      role="alert"
      className="flex flex-col gap-2 rounded-lg border border-brk-danger/40 bg-brk-danger/5 p-3 text-body text-brk-text sm:flex-row sm:items-center sm:justify-between"
    >
      <span>{problem}</span>
      <button
        type="button"
        onClick={onRetry}
        className={`${buttonClass({ variant: "secondary", size: "sm" })} self-start sm:self-auto`}
      >
        Retry
      </button>
    </div>
  );
}
